import React from "react";
import { useWidgets } from "../WidgetsProvider";
import Img from "../Img";
import Odd from "../Odd";
import Link from "../../router/Link";
import { getEventUrl } from "../../prematch/Prematch";
import { getLabel } from "../../InitData";

export default function LastMinute() {
    const widgetData = useWidgets();

    let events = null;

    try {
        const data = widgetData.lastMinute;
        events = data.matchesBySport[data.sports[0]];
    } catch (e) {}

    if (events == null) {
        return null;
    }

    return (
        <div className="c_9">
            <div className="c_9_1">
                <Img className="c_9_1_1" src="top_choice.svg" height="16px" width="16px" />
                <span className="c_9_1_2">{getLabel('top_choice')}</span>
            </div>
            <div className="c_9_2">
                {events.map(e => {
                    const bet = e.bets[0];
                    return (
                        <Link href={getEventUrl(e)} key={e.uniqueId} className="c_10">
                            <div className="c_10_1">
                                <div className="c_10_1_1">{e.date} {e.time}</div>
                                <div className="c_10_1_1">{e.fullDesc}</div>
                            </div>
                            <div className="c_10_2">{e.team1} - {e.team2}</div>
                            <div className="c_10_3">
                                <div className="c_10_3_1">
                                    <div className="c_10_3_1_1">{bet.desc}</div>
                                </div>
                                <div className="c_10_3_2">
                                    {bet.odds.map(o =>
                                        <Odd key={o.uniqueId} data={o} showDesc={true} />
                                    )}
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
